import React, { useContext, useEffect } from "react";
import {
  FundamentalFilmProduction,
  JoinUs,
  SubscribeFundamentalPackage
} from "../../Component";

import {
  LanguageProvider,
  FilmProductionProvider,
  FilmProductionContext,
  AboutusPageContext,
  AboutusPageProvider,
  PricingPageContext,
  PricingPageContextProvider
} from "../../store";
import styles from "./FilmProduction.module.css"

function FilmProduction() {
  // Simple scroll to top on initial load
  useEffect(() => {
    // Force scroll to top on component mount
    window.scrollTo(0, 0);
    
    // Use a more reliable approach to detect if this is a fresh page load vs. back navigation
    const handleLoad = () => {
      window.scrollTo(0, 0);
    };
    
    // Add load event listener
    window.addEventListener('load', handleLoad);
    
    return () => {
      window.removeEventListener('load', handleLoad);
    };
  }, []);
  
  const {
    filmproductionScreenDetails,
    loading: filmproductionLoading,
    error: filmproductionError,
  } = useContext(FilmProductionContext);

  useEffect(() => {
    if (filmproductionScreenDetails) {
      console.log(
        "Film Production Screen Details:",
        filmproductionScreenDetails
      );
    }
  }, [filmproductionScreenDetails]);

  const {
    aboutusScreenDetails,
    loading: aboutLoading,
    error: aboutError,
  } = useContext(AboutusPageContext);



  return (
    <div>
      <LanguageProvider>
        <FilmProductionProvider>
          <AboutusPageProvider>
            <div className={styles.elements}>
              <FundamentalFilmProduction />
            </div>
          </AboutusPageProvider>
        </FilmProductionProvider>
      </LanguageProvider>
    </div>
  );
}

export default FilmProduction;
